{
  "version": 1,
  "asset_id": "d44ba489-c2ce-44d8-963f-482e56a2ef0e",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/d44ba489-c2ce-44d8-963f-482e56a2ef0e/ukrp-hero.jpg",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/d44ba489-c2ce-44d8-963f-482e56a2ef0e/ukrp-hero.jpg",
  "original_filename": "ukrp-hero.jpg",
  "size": 179852,
  "content_type": "image/jpeg",
  "created_at": "2026-11-03T14:41:35Z"
}
